export default import.meta.ROLLUP_FILE_URL_mCyoOHsBrHrDniI3Op9rfA